import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { MonthYear } from "@common/types";
import { ICommandBase } from '@Quest/cqrs';
import { SaveViewAllProjectsPageCommandV1 } from "@Quest/Portfolios/Domain/commands-core";
import PortfoliosCommands from "@Quest/Portfolios/Domain/commands-vue-component";
import PortfoliosQueries from "@Quest/Portfolios/Domain/queries-vue-component";
import { AllProjectsPageReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { ProjectCompletedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectCompletedLifecycleSetter";
import ProjectCompletedLifecycleSetter from '@Quest/Projects/Components/ProjectCompletedLifecycleSetter.vue';
import { ProjectInProgressLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectInProgressLifecycleSetter";
import ProjectInProgressLifecycleSetter from '@Quest/Projects/Components/ProjectInProgressLifecycleSetter.vue';
import { ProjectPausedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectPausedLifecycleSetter";
import ProjectPausedLifecycleSetter from '@Quest/Projects/Components/ProjectPausedLifecycleSetter.vue';
import { ProjectProposalLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectProposalLifecycleSetter";
import ProjectProposalLifecycleSetter from '@Quest/Projects/Components/ProjectProposalLifecycleSetter.vue';
import { ProjectQualifiedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectQualifiedLifecycleSetter";
import ProjectQualifiedLifecycleSetter from '@Quest/Projects/Components/ProjectQualifiedLifecycleSetter.vue';
import { ProjectRejectedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectRejectedLifecycleSetter";
import ProjectRejectedLifecycleSetter from '@Quest/Projects/Components/ProjectRejectedLifecycleSetter.vue';
import { ProjectResumedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectResumedLifecycleSetter";
import ProjectResumedLifecycleSetter from '@Quest/Projects/Components/ProjectResumedLifecycleSetter.vue';
import { ProjectScheduledLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectScheduledLifecycleSetter";
import ProjectScheduledLifecycleSetter from '@Quest/Projects/Components/ProjectScheduledLifecycleSetter.vue';
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import { ProjectTerminatedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectTerminatedLifecycleSetter";
import ProjectTerminatedLifecycleSetter from '@Quest/Projects/Components/ProjectTerminatedLifecycleSetter.vue';
import { SetLifecycleCompletedCommandV1, SetLifecycleInProgressCommandV1, SetLifecyclePausedCommandV1, SetLifecycleProposalCommandV1, SetLifecycleQualifiedCommandV1, SetLifecycleRejectedCommandV1, SetLifecycleResumedCommandV1, SetLifecycleScheduledCommandV1, SetLifecycleTerminatedCommandV1 } from "@Quest/Projects/Domain/commands-core";
import ProjectsCommands from "@Quest/Projects/Domain/commands-vue-component";
import ProjectsQueries from '@Quest/Projects/Domain/queries-vue-component';
import { GridProjectReadModel } from '@Quest/Projects/Domain/readmodels';
import Vue from "vue";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, ProjectsGrid,
        ProjectProposalLifecycleSetter, ProjectQualifiedLifecycleSetter, ProjectRejectedLifecycleSetter,
        ProjectScheduledLifecycleSetter, ProjectInProgressLifecycleSetter, ProjectPausedLifecycleSetter, ProjectResumedLifecycleSetter,
        ProjectTerminatedLifecycleSetter, ProjectCompletedLifecycleSetter
    }
})
export default class AllProjectsPage extends mixins(PortfoliosQueries, PortfoliosCommands, ProjectsCommands, ProjectsQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: AllProjectsPageReadModel | null = null;
    get projects(): GridProjectReadModel[] { return this.rm?.Projects ?? []; }
    get portfolioId() { return this.rm.PortfolioId; }
    get portfolioName(): string | null { return this.rm?.PortfolioName; }

    grid: ProjectsGridViewModel = new ProjectsGridViewModel();

    projectQualifiedLifecycleSetter: ProjectQualifiedLifecycleSetterViewModel = new ProjectQualifiedLifecycleSetterViewModel();
    projectRejectedLifecycleSetter: ProjectRejectedLifecycleSetterViewModel = new ProjectRejectedLifecycleSetterViewModel();
    projectProposalLifecycleSetter: ProjectProposalLifecycleSetterViewModel = new ProjectProposalLifecycleSetterViewModel();
    projectScheduledLifecycleSetter: ProjectScheduledLifecycleSetterViewModel = new ProjectScheduledLifecycleSetterViewModel();
    projectInProgressLifecycleSetter: ProjectInProgressLifecycleSetterViewModel = new ProjectInProgressLifecycleSetterViewModel();
    projectPausedLifecycleSetter: ProjectPausedLifecycleSetterViewModel = new ProjectPausedLifecycleSetterViewModel();
    projectResumedLifecycleSetter: ProjectResumedLifecycleSetterViewModel = new ProjectResumedLifecycleSetterViewModel();
    projectTerminatedLifecycleSetter: ProjectTerminatedLifecycleSetterViewModel = new ProjectTerminatedLifecycleSetterViewModel();
    projectCompletedLifecycleSetter: ProjectCompletedLifecycleSetterViewModel = new ProjectCompletedLifecycleSetterViewModel();


    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveViewSettings()
    {
        const grid = this.grid.getJson();
        this.invokeSaveViewAllProjectsPageCommandV1(this.workspaceId, this.portfolioId, grid)
    }

    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }



    handleProposed(projectId: string)
    {
        this.invokeSetLifecycleProposalCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleQualified(projectId: string)
    {
        this.invokeSetLifecycleQualifiedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleRejected(projectId: string)
    {
        this.invokeSetLifecycleRejectedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleScheduled(projectId: string, startDate: MonthYear)
    {
        this.invokeSetLifecycleScheduledCommandV1(this.workspaceId, this.portfolioId, projectId, startDate);
    }

    handleStarted(projectId: string, startDate: MonthYear)
    {
        this.invokeSetLifecycleInProgressCommandV1(this.workspaceId, this.portfolioId, projectId, startDate);
    }

    handlePaused(projectId: string)
    {
        this.invokeSetLifecyclePausedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleResumed(projectId: string)
    {
        this.invokeSetLifecycleResumedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleTerminated(projectId: string)
    {
        this.invokeSetLifecycleTerminatedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleCompleted(projectId: string)
    {
        this.invokeSetLifecycleCompletedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }


    mounted()
    {
        document.title = "Portfolio All | TransparentChoice";
        this.runAllProjectsPageQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string): void 
    {
        if (modelName === "AllProjectsPageReadModel")
        {
            this.rm = model as AllProjectsPageReadModel;

            Vue.nextTick(() =>
            {
                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options);
                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
        else if (modelName === "GridProjectReadModel")
        {
            const rm = model as GridProjectReadModel;

            this.rm.Projects = this.rm.Projects.filter(p => p.Id !== rm.Id);
            this.rm.Projects.push(rm);

            this.grid.update(rm.Properties);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveViewAllProjectsPageCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
        else if (SetLifecycleProposalCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectProposalLifecycleSetter.close();
        }
        else if (SetLifecycleQualifiedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectQualifiedLifecycleSetter.close();
        }
        else if (SetLifecycleRejectedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectRejectedLifecycleSetter.close();
        }
        else if (SetLifecycleScheduledCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectScheduledLifecycleSetter.close();
        }
        else if (SetLifecycleInProgressCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectInProgressLifecycleSetter.close();
        }
        else if (SetLifecyclePausedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectPausedLifecycleSetter.close();
        }
        else if (SetLifecycleResumedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectResumedLifecycleSetter.close();
        }
        else if (SetLifecycleTerminatedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectTerminatedLifecycleSetter.close();
        }
        else if (SetLifecycleCompletedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);

            this.projectCompletedLifecycleSetter.close();
        }
    }
}
